// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface TDGroup {
  id: number;
  code: string;
  digits: string;
  active: boolean;
}

export interface AdminTDGroup extends TDGroup {
  student_count: number;
  project_group_count: number;
}

interface ActionResponse {
  message: string;
  [key: string]: any;
}

async function callApi(path: string, method: 'GET' | 'POST' | 'PUT', accessToken: string, body?: any): Promise<any> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(json.message || `HTTP error! status: ${response.status}`);
  }

  return json;
}

class TDGroupService {

  // Tous les groupes TD (actifs + inactifs) — chaque appelant filtre selon son besoin
  // (formulaires de nouvelle affectation : garder seulement 'active').
  async list(accessToken: string): Promise<TDGroup[]> {
    return callApi('/td-groups', 'GET', accessToken);
  }

  async listAdmin(accessToken: string): Promise<AdminTDGroup[]> {
    return callApi('/admin/td-groups', 'GET', accessToken);
  }

  async create(code: string, accessToken: string): Promise<ActionResponse> {
    return callApi('/admin/td-groups', 'POST', accessToken, { code });
  }

  async setActive(groupId: number, active: boolean, accessToken: string): Promise<ActionResponse> {
    return callApi(`/admin/td-groups/${groupId}`, 'PUT', accessToken, { active });
  }
}

export const tdGroupService = new TDGroupService();
